import { useCallback } from "react";

import { currenciesSelector, currencySelector, useGlobalSelector } from "core/stores/globalStore";
import useFormat from "core/hooks/useFormat";

import { 
    getCurrencyDecimalCount, 
    formatCurrencyWithSymbol as formatCurrencyWithSymbolHelper,
    convertCurrency as convertCurrencyHelper 
} from "./helpers";

const useCurrencies = () => {
    const currencies = useGlobalSelector(currenciesSelector);
    const currencyCode = useGlobalSelector(currencySelector);

    const { formatNumber } = useFormat()

    const formatAmount = useCallback((amount, currencyCode) => {
        if(amount === null || amount === undefined) return "-";

        const decimalCount = getCurrencyDecimalCount(currencyCode, currencies);
        let num = Number(amount);
        const degree = Math.pow(10, decimalCount);

        num = Math.trunc(num * degree) / degree

        return formatNumber( Number(num).toFixed( decimalCount ) );
    }, [currencies, formatNumber])


    const formatCurrencyWithSymbol = useCallback((currencyCode, value, addBrackats = true) => {
        return formatCurrencyWithSymbolHelper(currencyCode, currencies, value, addBrackats)
    }, [currencies])


    const convertCurrency = useCallback((amount = 0, from, to) => {
        if(!to) to = currencyCode;

        if(from?.toLowerCase() === to?.toLowerCase()) return amount;

        return convertCurrencyHelper(amount, from, to, currencies)
    }, [currencyCode, currencies])

    
    return {
        convertCurrency,
        formatAmount,
        formatCurrencyWithSymbol
    }
}

export default useCurrencies;